import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import AppraisalReportForm from "./AppraisalReportForm";
import SavedForms from "./SavedForms";
import EditForm from "./EditForm";
import Login from "./Login";
import PrivateRoute from "./PrivateRoute";
import AppraisalRequest from "./AppraisalRequest";
import SearchCertificate from "./SearchCertificate";
import EditAppraisalRequest from "./EditAppraisalRequest";
import DiminishedValueQuote from "./DiminishedValueQuote";

const App = () => {
  const [formData, setFormData] = useState({
    vehicleOwner: "",
    fileNumber: "",
    dateOfLoss: "",
    claimNumber: "",
    vin: "",
    odometerReading: "",
    fmv_high: 0,
    fmv_low: 0,
    a_high: 0,
    b_high: 0,
    c_high: 0,
  });

  const handleLogin = (token) => {
    localStorage.setItem("authToken", token); // Save token
    console.log("User logged in successfully");
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route
          path="/forms"
          element={
            <PrivateRoute>
              <SavedForms />
            </PrivateRoute>
          }
        />
        <Route
          path="/edit-form/:id"
          element={
            <PrivateRoute>
              <EditForm formData={formData} />
            </PrivateRoute>
          }
        />
        <Route
          path="/appraisal-request"
          element={
            <PrivateRoute>
              <AppraisalRequest />
            </PrivateRoute>
          }
        />
        <Route
          path="/edit-appraisal-request/:id"
          element={
            <PrivateRoute>
              <EditAppraisalRequest />
            </PrivateRoute>
          }
        />
        <Route
          path="/search-certificates"
          element={
            <PrivateRoute>
              <SearchCertificate />
            </PrivateRoute>
          }
        />

        <Route
          path="/dv-quote"
          element={
            <PrivateRoute>
              <DiminishedValueQuote />
            </PrivateRoute>
          }
        />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <AppraisalReportForm formData={formData} />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default App;
